import React from "react";

import FAAsterisk from "react-icons/lib/fa/asterisk";
import FACheck from "react-icons/lib/fa/check";

import { Flex } from "src/components";

import { colors } from "src/styles";

const ValidationIcon = ({ error, required, valid, style, ...props }) => {
  const iconProps = {
    style,
    size: 24,
  };

  let icon;

  if (required && valid) {
    icon = <FACheck {...iconProps} color={colors.success} />;
  } else if (required) {
    icon = (
      <FAAsterisk
        {...iconProps}
        color={error ? colors.alert : colors.muted}
        size={18}
      />
    );
  }

  if (icon) {
    return (
      <Flex height={24} align="center" {...props}>
        {icon}
      </Flex>
    );
  }

  return null;
};

export default ValidationIcon;



// WEBPACK FOOTER //
// ./src/components/Form/ValidationIcon.js